import Skeleton from "@mui/material/Skeleton";
import { styled as styling } from "@mui/material/styles";

// Skeleton Components //
export const ImageSkeleton = styling(Skeleton)((props) => ({
  borderRadius: "20px",

  [props.theme.breakpoints.up("lg")]: {
    minHeight: "160px",
    height: "12vw",
  },

  [props.theme.breakpoints.between(480, "lg")]: {
    minHeight: "130px",
    height: "17vw",
  },

  [props.theme.breakpoints.down(480)]: {
    minHeight: "240px",
    height: "17vw",
  },
}));

export const CompanyTitleSkeleton = styling(Skeleton)({
  marginTop: "20px",
});

export const CompanyIndustrySkeleton = styling(Skeleton)({
  marginTop: "10px",
  width: "60%",
});

export const CompanyJobCountSkeleton = styling(Skeleton)({
  marginTop: "10px",
  width: "60%",
});
